import React, { useEffect, useState } from "react";

import { TranslationsProvider } from "./context/translationsContext";
import CreateComment from "./createComment";
import CommentTree from "./commentTree";
import separateParentsChildren from "./utils/separateParentsChildren";

function WpComments({
  hostUrl,
  maxDepth,
  pageId,
  allowComments,
  user,
  translationOverrides,
  showStarRating,
}) {
  const [state, setState] = useState({
    topElements: null,
    childrenElements: null,
    commentsNumber: 0,
    isFetching: true,
    parentId: 0,
  });

  function setParentId(id) {
    setState(prevState => ({ ...prevState, parentId: id }));
  }

  // Fetch comments on mount / when hostUrl or pageId changes
  useEffect(() => {
    const url = new URL(`${hostUrl}/wp-json/wp/v2/comments`);
    const params = { post: pageId, per_page: 100 };
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));

    fetch(url.toString(), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => (response.ok ? response.json() : null))
      .then(resultData => {
        const commentsNumber = Array.isArray(resultData) ? resultData.length : 0;
        const [topElements, childrenElements] = separateParentsChildren(resultData || []);
        setState({
          topElements,
          childrenElements,
          commentsNumber,
          isFetching: false,
          parentId: 0,
        });
      })
      .catch(err => {
        console.error(err);
        setState(prev => ({ ...prev, isFetching: false }));
      });
  }, [hostUrl, pageId]);

  if (state.isFetching) {
    return <p>Loading comments...</p>;
  }

  const restUrl = `${hostUrl}/wp-json/wp/v2/comments`;

  return (
    <TranslationsProvider overrides={translationOverrides}>
      <div className="comments-area">
        <div className="comments-title">
          <h2>Comments section ({state.commentsNumber})</h2>
        </div>
        <div>
          <ol className="comment-list">
            {CommentTree(
              state.topElements,
              state.childrenElements,
              maxDepth,
              0,
              state.parentId,
              pageId,
              restUrl,
              setParentId,
              allowComments,
              user
            )}
          </ol>
          {state.parentId === 0 ? (
            <CreateComment
              allowComments={allowComments}
              pageId={pageId}
              parentId={0}
              restUrl={restUrl}
              user={user}
              showStarRating={showStarRating}
            />
          ) : null}
        </div>
      </div>
    </TranslationsProvider>
  );
}

export { WpComments };
export default WpComments;